import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function typography(_ref, theme) {
  var fontSize = _ref.fontSize,
      styles = _objectWithoutPropertiesLoose(_ref, ["fontSize"]);

  if (typeof fontSize !== 'undefined') {
    var value = theme && theme.fontSizes ? theme.fontSizes[fontSize] || fontSize : fontSize;
    styles.fontSize = typeof value === 'number' ? value + 'px' : value;
  }

  return styles;
}

export default typography;